import { BaseService } from './base-service';

class UserService extends BaseService {
  /**
   * 应用初始化
   *
   * @author ylq
   * @param  {Object} params
   * @returns
   * @memberof UserService
   */
  init(data) {
    return this.request({
      method: 'post',
      url: `/auth/reIsvLogin`,
      data
    });
  }

  /**
   *  获取当前用户信息
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params.key
   * @param  {String} params.code
   * @returns
   * @memberof UserService
   */
  getUserInfo(params) {
    return this.request({
      method: 'get',
      url: `/user/get`,
      params
    });
  }
  /**
   *  刷新状态
   *
   * @author ylq
   * @param  {Object} params
   * @returns
   * @memberof UserService
   */
  refreshState() {
    return this.request({
      method: 'get',
      url: `/sso/v1/refreshState`
    });
  }
  /**
   *  退出登录
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params.key
   * @param  {String} params.code
   * @returns
   * @memberof UserService
   */
  logout(params) {
    return this.request({
      method: 'get',
      url: `/auth/logout`,
      params
    });
  }
  /**
   *  临时的一个获取表格的列表 后续要销毁掉
   *
   * @author ylq
   * @param  {Object} params
   * @returns
   * @memberof UserService
   */
  getUserList(params) {
    return this.request({
      method: 'get',
      url: `/client/department/users/${params.departId || 0}`,
      params
    });
  }
  /**
   * 获取code值后登录
   *
   * @author ylq
   * @param  {Object} params
   * @returns
   * @memberof UserService
   */
  login(data) {
    return this.request({
      method: 'post',
      url: `/auth/login`,
      data
    });
  }
  //获取用户菜单列表-新 2024年01月17日11:49:38 zl
  getUserResource(params) {
    return this.request({
      method: 'GET',
      url: `/user/resource/get`,
      params
    });
  }
  /**
   * 多租户登录--飞书侧登录--获取appId
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  loginMultiTenant(params) {
    return this.request({
      method: 'get',
      url: `/auth/getAppListByKeyName`,
      params
    });
  }
  /**
   * 多租户登录--账号密码登录--根据租户id登录
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  accountLogin(data) {
    return this.request({
      method: 'post',
      url: `/auth/v2/login`,
      data
    });
  }
  /**
   * 账号密码登录--效验账号是否存在
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  verifyAccount(params) {
    return this.request({
      method: 'get',
      url: `/auth/verify`,
      params
    });
  }
  /**
   * 发送验证码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  verifyCode(data) {
    return this.request({
      method: 'post',
      url: `/auth/send/verify/code`,
      data
    });
  }
  /**
   * 校验验证码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  checkVerifyCode(data) {
    return this.request({
      method: 'post',
      url: `/auth/check/verify/code`,
      data
    });
  }
  /**
   * 统一登录
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  unifyLogin(data) {
    return this.request({
      method: 'post',
      url: `/auth/unify/login`,
      data
    });
  }
  /**
   * 修改密码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  updatePassword(data) {
    return this.request({
      method: 'post',
      url: `/auth/update/password`,
      data
    });
  }
  /**
   * 忘记密码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  forgotPassword(data) {
    return this.request({
      method: 'post',
      url: `/auth/forgot/password`,
      data
    });
  }
  /**
   * 获取初始密码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getTeantInfo(params) {
    return this.request({
      method: 'get',
      url: `/user/getTeantPassword`,
      params
    });
  }
  /**
   * 校验原密码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  originalPassword(data) {
    return this.request({
      method: 'post',
      url: `/auth/check/original/password`,
      data
    });
  }
  /**
   * 成员列表---重置用户密码
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  resetPwd(params) {
    return this.request({
      method: 'get',
      url: `/user/resetPwd`,
      params
    });
  }
  /**
   * 树形结构---租户名称修改
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  updateTenantName(params) {
    return this.request({
      method: 'get',
      url: `/user/updateTenantName`,
      params
    });
  }
  /**
   * 成员列表---变更部门、批量变更部门
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  batchUpdateDepartment(data) {
    return this.request({
      method: 'post',
      url: `/sysDepartment/batchUpdateDepartment`,
      data
    });
  }
  /**
   * 部门树形结构中---删除部门
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  deleteDept(params) {
    return this.request({
      method: 'get',
      url: `sysDepartment/delete`,
      params
    });
  }
  /**
   * 公司/部门 新增和修改
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  saveOrUpdate(data) {
    return this.request({
      method: 'post',
      url: `sysDepartment/saveOrUpdate`,
      data
    });
  }
  /**
   * 成员页面获取租户/公司/部门坐席等信息
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getTenantInfo(params) {
    return this.request({
      method: 'get',
      url: `/user/getTenantInfo`,
      params
    });
  }
  /**
   * 成员列表--取消合并
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  unMergeUser(params) {
    return this.request({
      method: 'get',
      url: `/user/unMergeUser`,
      params
    });
  }
  /**
   * 公司列表查询
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getCompanyList(params) {
    return this.request({
      method: 'get',
      url: `/company/list`,
      params
    });
  }
  /**
   * 部门列表查询
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getDepartmentTreeList(data) {
    return this.request({
      method: 'post',
      url: `/sysDepartment/getDepartmentTreeList`,
      data
    });
  }
  /**
   * 新建编辑成员
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  userSaveOrUpdate(data) {
    return this.request({
      method: 'post',
      url: `/user/saveOrUpdate`,
      data
    });
  }
  /**
   * 成员批量开启/关闭坐席
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  modifySeatStatusBatch(data) {
    return this.request({
      method: 'post',
      url: `/user/modifySeatStatusBatch`,
      data
    });
  }
  /**
   * 成员批量操作离职
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  userDimission(data) {
    return this.request({
      method: 'post',
      url: `/user/dimission`,
      data
    });
  }
  /**
   * 成员批量变更角色
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  modifyRolesBatch(data) {
    return this.request({
      method: 'post',
      url: `/user/modifyRolesBatch`,
      data
    });
  }
  /**
   * 成员树形结构上移下移接口
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  upOrDown(params) {
    return this.request({
      method: 'get',
      url: `/sysDepartment/upOrDown`,
      params
    });
  }
  /**
   * 成员树形结构拖拽
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  dragNode(data) {
    return this.request({
      method: 'post',
      url: `/sysDepartment/dragNode`,
      data
    });
  }
  /**
   * 同步记录
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  syncRecordList(params) {
    return this.request({
      method: 'get',
      url: `/syncRecord/list`,
      params
    });
  }
  /**
   * 成员--获取剩余空闲坐席数量
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getFreeSeatCount(params) {
    return this.request({
      method: 'get',
      url: `/user/getFreeSeatCount`,
      params
    });
  }
  /**
   * 登录--绑定手机号
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getBindMobile(params) {
    return this.request({
      method: 'get',
      url: `/user/bindMobile`,
      params
    });
  }
  /**
   * 公司--取消关联三方
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  cancelRelationCompany(params) {
    return this.request({
      method: 'get',
      url: `/company/cancelRelationCompany`,
      params
    });
  }
  /**
   * 公司--自建公司关联三方
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  relationCompany(data) {
    return this.request({
      method: 'post',
      url: `/company/relationCompany`,
      data
    });
  }
  /**
   * 获取城市级联列表
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getSelectionsByFiledKey(params) {
    return this.request({
      method: 'get',
      url: `global_field/getSelectionsByFiledKey`,
      params
    });
  }
  /**
   * 无权限通知当前登录人去找管理员
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getAdmin() {
    return this.request({
      method: 'get',
      url: `/auth/notify/admin`
    });
  }
  /**
   * 失焦检查手机号和邮箱是否重复
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  checkMobileAndEmail(params) {
    return this.request({
      method: 'get',
      url: `auth/checkMobileAndEmail`,
      params
    });
  }
  /**
   * 切换身份接口
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  changeUser(params) {
    return this.request({
      method: 'get',
      url: `auth/changeUser`,
      params
    });
  }
  /**
   * 查询初始化状态
   *
   * @author jnn
   * @returns
   * @memberof userService
   */
  checkTemplateInit(params) {
    return this.request({
      method: 'get',
      url: `/auth/checkTemplateInit`,
      params
    });
  }
  /**
   * 查询所有模板
   *
   * @author jnn
   * @returns
   * @memberof userService
   */
  getInitTemplate(params) {
    return this.request({
      method: 'get',
      url: `/auth/getInitTemplate`,
      params
    });
  }
  /**
   * 初始化或再次初始化
   *
   * @author jnn
   * @returns
   * @memberof userService
   */
  initTemplate(params) {
    return this.request({
      method: 'get',
      url: `/auth/initTemplate`,
      params
    });
  }

  /**
   * 刷新页面后获取applist
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getAppList(params) {
    return this.request({
      method: 'get',
      url: `auth/getAppList`,
      params
    });
  }

  /**
   * 是否必须填写手机号
   * @author Qushijie
   * @returns
   * @memberof userService
   */
  requiredMobile() {
    return this.request({
      method: 'get',
      url: `auth/requiredMobile`
    });
  }
  //获取应用凭证
  getAppSecret() {
    return this.request({
      method: 'get',
      url: `connect/get?type=2`
    });
  }
  //获取应用凭证
  getResetAppSecret() {
    return this.request({
      method: 'get',
      url: `connect/reset?type=2`
    });
  }
  /**
   * 获取管理员列表
   *
   * @author CaoJianBo
   * @returns
   * @memberof userService
   */
  getAdminUserList(params) {
    return this.request({
      method: 'get',
      url: `user/admin/list`,
      params
    });
  }
}

export const userService = new UserService();
